<template>
  <div>
    <md-dialog
            :title="title"
            :closable="false"
            layout="column"
            v-model="open"
            :btns="btns"
    >
      购买后可报名参加对应课包次数的任意同类型活动
    </md-dialog>
  </div>
</template>

<script>
import {Dialog} from 'mand-mobile'

export default {
  name: "BuyCourseBundle",
  components: {
      [Dialog.name]: Dialog,
  },
  props: ['type', 'title'],
    data() {
      return {
          open: false,
          btns: [],
      }
    },
    created() {
      this.loadData();
    },
  methods: {
      loadData() {
          this.$toast.loading("加载中...");
          this.$http.get(`course-bundles?type=` + this.type)
              .then(({data}) => {
                  this.$toast.hide();
                  const btns = [];
                  data.forEach((d) => {
                      btns.push({
                          text:  `${d.qty}次课包(${d.price}元)`,
                          handler: () => this.buy(d.id),
                      });
                  });
                  btns.push({
                      text: '取消',
                      handler: this.onBasicCancel,
                  });
                  this.btns = btns;
                  this.open = true;
              })
              .catch(err => {
                  this.$toast.hide();
                  console.log(err);
              });
      },
      close() {
          this.$emit('close');
      },
      onBasicCancel() {
          this.close();
      },
      buy(id) {
        console.log(id);
          this.$toast.loading("加载中...");
          this.$http.post(`course-bundles/${id}`)
              .then(({data}) => {
                  //this.$toast.hide();
                  this.doPayment(data);
              })
              .catch(({response}) => {
                  this.$toast.hide();
              });
      },
      doPayment(sign) {
          this.$tools.wechatPay(sign)
              .then(() => {
                  this.$toast.hide();
                  this.$emit("onPaymentSuccess");
              })
              .catch((res) => {
                  this.$toast.hide();
                  console.log(res);
                  this.$toast.failed('支付失败，请重试');
              });
      },
  }
};
</script>

<style lang="scss" scoped>

</style>
